module.exports = __webpack_public_path__ + "assets/img/logo-index.eb5ec1de.svg";